export default __webpack_public_path__ + "static/media/0ad83cb9c3a2906afeb360c2b05234fb1600871063669.1fbefda2.webp";